export default __webpack_public_path__ + "static/578-52b2dd9fe1feea6acc335af42b070701.gif";